module.exports = __webpack_public_path__ + "img/pix.9018888b.png";